// extracted by mini-css-extract-plugin
module.exports = {"recommendationSectionResponsive":"Recommendations_recommendationSectionResponsive__fOb_y"};